var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 79,
    viewBox: "0 0 123 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_31)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.17 0.36L121.87 13.75C122.41 13.85 122.87 14.2 122.87 14.75V63.6C122.87 64.15 122.41 64.51 121.87 64.6L48.17 78.07C47.63 78.17 47.17 77.62 47.17 77.07V1.36C47.17 0.81 47.63 0.26 48.17 0.36ZM0.69 7.06L10.72 5.39V72.98L0.69 71.28C0.31 71.21 0 70.97 0 70.59V7.75C0 7.37 0.31 7.13 0.69 7.06ZM14.6 4.74L26.04 2.83V75.58L14.6 73.65V4.74ZM29.93 2.19L43.04 0.0100001C43.41 -0.0499999 43.73 0.32 43.73 0.7V77.8C43.73 78.18 43.42 78.55 43.04 78.49L29.93 76.26V2.45V2.19ZM119.34 18.2V60.25H118.04V18.2H119.34ZM57.63 9.83V69.89H53.74V8.63L57.63 9.83ZM68.28 10.82V68.3H64.71V10.36L68.28 10.82ZM77.81 12.36V66.69H74.57V11.75L77.81 12.36ZM86.31 13.69V65.52H83.39V13.01L86.31 13.69ZM94.15 14.95V64.08H91.55V14.41L94.15 14.95ZM101.38 15.86V62.97H99.11V15.34L101.38 15.86ZM107.86 17.04V61.96H105.91V16.43L107.86 17.04ZM113.9 18.06V61.03H112.28V17.31L113.9 18.06Z",
    fill: "#1e5eff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.88,
    height: 78.5,
    fill: "#1e5eff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPrimary);
export default __webpack_public_path__ + "static/media/LogoPrimary.9cd11dbfead0d83d536fc4dc93ae9ad8.svg";
export { ForwardRef as ReactComponent };